//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mfg.AM.js";
import "../no/DisplayableObject.js";
let d=[[[0,"SupportType",0,0]],[[[],"GetSurfaceRegion",{R_:{surfaceRegion:"Mfg.AM.SurfaceRegion"}},0,0],[[],"GetGeometry",{R_:{tagGeometry:"DisplayableObject"}},0,1],[["tagGeometry"],"SetSimulationSupport",{},1,0],[[],"GetSimulationSupport",{R_:{tagGeometry:"Mfg.AM.SimulationSupport"}},0,0],[["numObjects"],"GetGeometries",{R_:{tagGeometry:"DisplayableObject[]"}},0,0],[[],"Regenerate",{},0,0]],[]];
SPLM.Mfg.AM.Support = class extends SPLM.DisplayableObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mfg.AM.Support";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mfg.AM.Support.Type = Object.freeze({
    "None" : "None", "Block" : "Block", "Line" : "Line", "Point" : "Point", "Volume" : "Volume", "Web" : "Web", "Contour" : "Contour", "Gusset" : "Gusset", "Combined" : "Combined", "Tree" : "Tree", "Hybrid" : "Hybrid", "UserDefined" : "UserDefined"});

export default SPLM;